import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useMemo, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import { REMOVE_PRODUCTS_FROM_WISHLIST } from '@magento/peregrine/lib/talons/WishlistPage/wishlistItem.gql';
import DEFAULT_OPERATIONS from './wishlistDialog.gql';
import { Check, AlertCircle } from 'react-feather';
import Icon from '@magento/venia-ui/lib/components/Icon';
import { useToasts } from '@magento/peregrine';
var CheckIcon = React.createElement(Icon, {
  size: 20,
  alt: "Success icon",
  src: Check
});
var ErrorIcon = React.createElement(Icon, {
  size: 20,
  alt: "Error icon",
  src: AlertCircle
});
export var useWishlistDialog = function useWishlistDialog(props) {
  var isLoading = props.isLoading,
      itemOptions = props.itemOptions,
      onClose = props.onClose,
      onSuccess = props.onSuccess;
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 2),
      addToast = _useToasts2[1].addToast;

  var toast = function toast(text) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    return addToast({
      type: type,
      icon: type === 'success' ? CheckIcon : ErrorIcon,
      message: formatMessage({
        id: text,
        defaultMessage: text
      }),
      timeout: 5000
    });
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormOpen = _useState2[0],
      setIsFormOpen = _useState2[1];

  var _useQuery = useQuery(operations.getWishlistsQuery, {
    fetchPolicy: 'cache-and-network'
  }),
      wishlistsData = _useQuery.data,
      loadingWishlistData = _useQuery.loading;

  var _useMutation = useMutation(REMOVE_PRODUCTS_FROM_WISHLIST),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      removeProductFromWishlistMutation = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      loadingRemoveFromWishlist = _useMutation2$.loading,
      errorRemoveFromWishlist = _useMutation2$.error;

  var removeProductFromWishlist = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
      var message, input;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              message = props.message, input = props.input;
              _context.prev = 1;
              _context.next = 4;
              return removeProductFromWishlistMutation({
                variables: input
              });

            case 4:
              // refetchWishlist();
              if (message) toast(message);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              toast(_context.t0.message, 'error');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function removeProductFromWishlist(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation3 = useMutation(operations.addProductToWishlistMutation, {
    refetchQueries: [{
      query: operations.getWishlistsQuery
    }]
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      addProductToWishlist = _useMutation4[0],
      _useMutation4$ = _useMutation4[1],
      isAddLoading = _useMutation4$.loading,
      addProductError = _useMutation4$.error; // enable_multiple_wishlists is a string "1" or "0". See documentation here:
  // https://devdocs.magento.com/guides/v2.4/graphql/mutations/create-wishlist.html


  var canCreateWishlist = useMemo(function () {
    var _wishlistsData$storeC, _wishlistsData$storeC2, _wishlistsData$custom, _wishlistsData$custom2;

    return wishlistsData && !!(wishlistsData !== null && wishlistsData !== void 0 && (_wishlistsData$storeC = wishlistsData.storeConfig) !== null && _wishlistsData$storeC !== void 0 && _wishlistsData$storeC.enable_multiple_wishlists) && (wishlistsData === null || wishlistsData === void 0 ? void 0 : (_wishlistsData$storeC2 = wishlistsData.storeConfig) === null || _wishlistsData$storeC2 === void 0 ? void 0 : _wishlistsData$storeC2.maximum_number_of_wishlists) > (wishlistsData === null || wishlistsData === void 0 ? void 0 : (_wishlistsData$custom = wishlistsData.customer) === null || _wishlistsData$custom === void 0 ? void 0 : (_wishlistsData$custom2 = _wishlistsData$custom.wishlists) === null || _wishlistsData$custom2 === void 0 ? void 0 : _wishlistsData$custom2.length);
  }, [wishlistsData]);
  var handleAddToWishlist = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(wishlistId) {
      var _yield$addProductToWi, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return addProductToWishlist({
                variables: {
                  wishlistId: wishlistId,
                  itemOptions: itemOptions
                },
                refetchQueries: [{
                  query: operations.getWishlistsQuery
                }]
              });

            case 3:
              _yield$addProductToWi = _context2.sent;
              data = _yield$addProductToWi.data;

              if (!onSuccess) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return onSuccess(data);

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [addProductToWishlist, itemOptions, onClose, onSuccess]);
  var handleNewListClick = useCallback(function () {
    setIsFormOpen(true);
  }, []);
  var handleCancelNewList = useCallback(function () {
    setIsFormOpen(false);
  }, []);
  var handleCancel = useCallback(function () {
    onClose();
    setIsFormOpen(false);
  }, [onClose]);
  return {
    formErrors: [addProductError],
    canCreateWishlist: canCreateWishlist,
    handleAddToWishlist: handleAddToWishlist,
    handleCancel: handleCancel,
    handleCancelNewList: handleCancelNewList,
    handleNewListClick: handleNewListClick,
    isLoading: isLoading || isAddLoading,
    isFormOpen: isFormOpen,
    wishlistsData: wishlistsData,
    removeProductFromWishlist: removeProductFromWishlist,
    loadingRemoveFromWishlist: loadingRemoveFromWishlist,
    loadingAddingtoWishlist: isAddLoading,
    loadingWishlistData: loadingWishlistData
  };
};